module.exports = __webpack_public_path__ + "static/media/profile.1346915e.png";